module.exports = new __parcel__URL__("passResetStrand.fa35c967.svg").toString();